export function VectorSplashIcon({
  height = 24,
  color = '#fff',
}: {
  height?: number;
  color?: string;
}) {
  return (
    <svg
      width={50 * (height / 24)}
      height={height}
      viewBox="0 0 50 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0583 6.03294C30.3921 1.94108 33.6808 0.579956 37.8031 0.579956C44.115 0.579956 49.2261 5.69407 49.2261 11.9999C49.2261 18.3057 44.1122 23.4198 37.8003 23.4198H18.3136C12.0045 23.4198 6.88773 18.3085 6.88773 11.9999H10.038C10.038 15.0921 13.4398 17.5969 17.6383 17.5969C19.6217 17.5969 21.43 17.0349 22.7833 16.1171C25.0691 14.7121 25.8648 12.1657 26.6341 9.70348C27.043 8.39484 27.4445 7.10999 28.0583 6.03294ZM42.1203 6.1346C41.6626 6.59208 41.6626 7.33759 42.1203 7.79506C42.578 8.25254 43.3239 8.25254 43.7816 7.79506C44.2393 7.33759 44.2393 6.59208 43.7816 6.1346C43.3239 5.67713 42.578 5.67713 42.1203 6.1346ZM12.6949 2.495H16.1362C16.1362 6.72805 12.7034 10.1591 8.46814 10.1591C4.23289 10.1591 0.800049 6.72805 0.800049 2.495H4.24137C5.36022 2.495 6.41974 3.0033 7.11761 3.87589L8.46814 5.56177L9.81867 3.87589C10.5165 3.0033 11.5761 2.495 12.6949 2.495Z"
        fill={color}
      />
    </svg>
  );
}
